import { FC } from "react";
import { ProForm, ProInputNumber } from '../../antd';
import { STATUS_CREATED_CODE } from '../../constants/constant';
import { ADD_KEY, TableRowProps } from "../interface";
import { formatRowKey } from "../util";

const TableRow: FC<TableRowProps> = props => {
  const { disabled, ...restProps } = props;
  const dataRowKey = props['data-row-key'];
  if (dataRowKey === undefined) return <tr {...props}></tr>;
  if (dataRowKey.includes(ADD_KEY) && disabled) return null; 
  const rowKey = formatRowKey(dataRowKey);

  return (
    <>
      <ProForm.Item name={[rowKey.mainKey, rowKey.childrenKey, STATUS_CREATED_CODE]} hidden={true}>
        <ProInputNumber />
      </ProForm.Item>
      <tr {...restProps} />
    </>
  );
};

export default TableRow;
